import { FlowerLogo } from "./FlowerLogo";
import { Monitor } from "lucide-react";
import { Button } from "./ui/button";
import { useI18n } from "../lib/i18n";

const links = [
  ["status", "navStatus", "#status"],
  ["register", "navRegister", "#register"],
  ["clients", "navClients", "#clients"],
  ["faq", "navFaq", "#faq"],
];

export const Navbar = ({ status, onRetro }) => {
  const { t, lang, setLang } = useI18n();
  const online = status?.online;
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0D1117]/75 border-b border-[#30363D]">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 py-3">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <FlowerLogo size={30} online={online !== false} className="transition-transform duration-500 group-hover:rotate-45" />
          <span className="font-display font-extrabold text-xl tracking-tight">KICQ</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map(([id, key, href]) => (
            <a key={href} href={href} data-testid={`nav-link-${id}`}
              className="text-sm text-[#8B949E] hover:text-[#F0F6FC] transition-colors">
              {t(key)}
            </a>
          ))}
          <a href="https://kicq.su" target="_blank" rel="noopener noreferrer" data-testid="nav-link-webclient"
            className="text-sm text-[#38BDF8] hover:text-[#F0F6FC] transition-colors">
            {t("navWeb")}
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <span data-testid="nav-server-badge"
            className="hidden sm:flex items-center gap-2 font-mono text-xs px-3 py-1.5 rounded-full border border-[#30363D] bg-[#161B22]">
            <span className={`h-2 w-2 rounded-full ${online ? "bg-[#3FB950] pulse-ring" : online === false ? "bg-[#F85149]" : "bg-[#D29922]"}`} />
            {online ? `${status.latency_ms}${t("ms")}` : online === false ? t("offline") : "..."}
          </span>
          <div data-testid="lang-switcher" className="flex rounded-full border border-[#30363D] bg-[#161B22] p-0.5 font-mono text-xs">
            {["ru", "en"].map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`lang-${l}-btn`}
                className={`px-2.5 py-1 rounded-full uppercase transition-colors ${lang === l ? "bg-[#3FB950] text-[#0D1117] font-semibold" : "text-[#8B949E] hover:text-[#F0F6FC]"}`}>
                {l}
              </button>
            ))}
          </div>
          <button onClick={onRetro} data-testid="theme-toggle-btn" title={t("themeRetro")}
            className="flex items-center gap-1.5 rounded-full border border-[#30363D] bg-[#161B22] px-2.5 py-1.5 font-mono text-xs text-[#8B949E] hover:text-[#F0F6FC] hover:border-[#3FB950]/60 transition-colors">
            <Monitor className="h-3.5 w-3.5" /><span className="hidden sm:inline">{t("themeRetro")}</span>
          </button>
          <Button asChild data-testid="nav-register-btn"
            className="rounded-full bg-[#3FB950] text-[#0D1117] hover:bg-[#2EA043] font-semibold">
            <a href="#register">{t("getUin")}</a>
          </Button>
        </div>
      </div>
    </header>
  );
};
